import React from 'react';
import { Section } from '../Section';
import { Panel } from '../ui/Panel';
import { Pill } from '../ui/Pill';
import { rituals } from '../../data/caseStudy';
const retro = [{
  label: 'Observed',
  body: 'The design system was in place when I joined, but the client wasn’t especially design-literate and adherence loosened as the MVP deadline closed in.'
}, {
  label: 'Impact',
  body: "Engineers began building straight from Figma files rather than the documented components and hand-off got less tight than it should have been."
}, {
  label: 'Change',
  body: "If I'd been involved earlier, I would have focused on identifying where design governance had broken down before it became a late-stage scramble. Addressing those root causes upstream would have created more time to solve the underlying issues, rather than managing their consequences."
}];
export function Collaboration() {
  return <Section number="04" kicker="Ways of working" title="Working with engineers, day to day" lede="Hand-off was kept smooth through daily stand-ups with engineers and analysts, and a second designer holding UI consistency across both workstreams." tone="mist" data-id="element-59" data-mp="zuasg2vdnxu8">
      <div className="grid grid-cols-3 gap-5" data-id="element-60" data-mp="2vyx90ov0ime8">
        {rituals.map(ritual => <Panel key={ritual.title} padding="sm" data-id="element-61" data-mp="30yjq59dyomsb">
            <Pill variant="neutral" data-id="element-62" data-mp="35qjl0nf6cpi1">Ritual</Pill>
            <h3 className="mt-5 font-display text-[19px] font-semibold leading-tight tracking-[-0.02em] text-navy" data-id="element-63" data-mp="35se6q3y9sln6">
              {ritual.title}
            </h3>
            <p className="mt-3 font-sans text-[14px] leading-[1.7] text-ink-muted" data-id="element-64" data-mp="3fohh1x39zql7">{ritual.body}</p>
          </Panel>)}
      </div>

      <div className="avoid-break mt-8 overflow-hidden rounded-2xl border border-white/10 bg-navy-deep" data-id="element-65" data-mp="3jrvzeueosj1t">
        <div className="flex items-center gap-3 border-b border-white/10 px-8 py-5" data-id="element-66" data-mp="3op5m42aoygly">
          <span className="accent-rule h-4 w-1 rounded-full" aria-hidden="true" data-id="element-67" data-mp="1pdv2if2p664d" />
          <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.18em] text-white/60" data-id="element-68" data-mp="1uauxnuy0dogp">
            Retro — what I noticed, and would change
          </p>
        </div>
        <div className="grid grid-cols-3 divide-x divide-white/10" data-id="element-69" data-mp="2snqtrk9iob69">
          {retro.map(item => <div key={item.label} className="px-8 py-8" data-id="element-70" data-mp="36n8kw6aac0is">
              <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.18em] text-green" data-id="element-71" data-mp="36otentorzffl">
                {item.label}
              </p>
              <p className="mt-4 font-sans text-[15px] leading-[1.75] text-white/65" data-id="element-72" data-mp="3gl64uhl43b5l">{item.body}</p>
            </div>)}
        </div>
      </div>
    </Section>;
}